import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RestudyEconomicManagerDecision,RestudyEconomicDecision ,FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ReleaseRestudyRequestDTO, ReleaseRestudyAdminDTO } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import {  Router ,ActivatedRoute} from '@angular/router';
import { AppConfig } from 'src/app/shared/services/app.config';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';

@Component({
  selector: 'app-Restudy-economic-manager',
  templateUrl: './Restudy-economic-manager.component.html'
})
export class RestudyEconomicManagerComponent {
  submitted = false;
  loading = false;
  showRequest: boolean = false;
  showEconomicDecision :boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  restudyRequestObj: ReleaseRestudyRequestDTO = new ReleaseRestudyRequestDTO();
  restudyAdminObj: ReleaseRestudyAdminDTO = new ReleaseRestudyAdminDTO();
  decision = RestudyEconomicManagerDecision;
  managerdecision=RestudyEconomicDecision;
  eunitSignedUsersCount: number;
  decisionKeys = Object.keys(this.decision);
  ManagerdecisionKeys = Object.keys(this.managerdecision);
  displayedLang: string;
  ShowApprove: boolean = false;
  showAttachment: boolean = false;
  ShowModify: boolean = false;
  decisionValue: number;
  MdecisionValue: number = 0;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  @Input() public baseRequestId: string = '';
  showProceedToManagers: boolean = false;
  isRestudyRoute: boolean = false;
  isReportURL: boolean = false;
  user: User = new User();
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;
  uploadFolder = AppConfig.settings.apiServer.ReleaseUploadsFolder;
  restudyManagerForm: FormGroup;
  EconomicManagerForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatus: number;
  @Input() public isShow: boolean = true;
  @Input() public showRequestDetails: boolean = true;
  isLoaded: boolean = false;
  ListOfAdmins: [] = [];
  adminsDropdownSettings = {};
  selectedEmails: [] = [];
  currentRoute: string = '';

  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private route: Router,
    private router: ActivatedRoute,
    private longhaulserv: LongHaulService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.ManagerdecisionKeys = this.ManagerdecisionKeys.slice(this.ManagerdecisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    const currentUrl = this.route.url;
    this.isRestudyRoute = currentUrl.includes('/RestudyEconomicManagerApproval');
    this.isReportURL = currentUrl.includes('/RestudyRequest');
    this.user = this.globalSrv.user;
    this.adminsDropdownSettings = {
      singleSelection: false,
      idField: 'Email',
      textField: 'Username',
      selectAllText: 'Select All',
      unSelectAllText:  'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: true
    };
  }
  ngOnInit() {
    this.currentRoute = this.router.snapshot.routeConfig?.path || '';
    if (this.baseRequestId != "") {
      this.getRequest();
    }
    else if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.buildManagerForm(1);
    this.buildForm(1);
  }

  buildManagerForm(decisionValue) {

    this.EconomicManagerForm = this.formBuilder.group({
      ManagerDecision: ['', [Validators.required]],
    })
    if (decisionValue == RestudyEconomicDecision.ManagerApprove) {
      this.EconomicManagerForm = this.formBuilder.group({
        ManagerDecision: ['', [Validators.required]],
       // ManagerApprove: ['',[Validators.required]]
      });
    }
    else if (decisionValue == RestudyEconomicDecision.ManagerModify) {
      this.EconomicManagerForm = this.formBuilder.group({
        ManagerDecision: ['', [Validators.required]],
        ManagerModify: ['', [Validators.required]],
      });
    }
    if(!this.isRestudyRoute){
      this.EconomicManagerForm.disable();
    }
  }
  buildForm(decision) {

    /*this.restudyManagerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });*/
    if (decision == RestudyEconomicManagerDecision.Approve) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Approve: ['',[Validators.required]]
      });
    }
    else if (decision == RestudyEconomicManagerDecision.Modify) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Modify: ['', [Validators.required]],
        Approve: ['',[Validators.required]]
      });
    }
    else if (decision == RestudyEconomicManagerDecision.Cancel) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Cancel: ['', [Validators.required]],
      });
    }
    else if (decision == RestudyEconomicManagerDecision.MoreInformation) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }

  }
  get form() {
    return this.EconomicManagerForm.controls;
  }
  get form1() {
    return this.restudyManagerForm.controls;
  }

  changeDecision(value) {


    this.buildManagerForm(value);
    this.EconomicManagerForm.patchValue({
      ManagerDecision: value
    });
    if(value==2){
      this.ShowModify = true;
      this.ShowApprove = false;
    }
    else{
      this.ShowModify = false;
      this.ShowApprove = false;
    }

    this.MdecisionValue = value;
  }

  getRequest() {

    this.longhaulserv.GetRestudyRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.restudyRequestObj = this.responseObj.Data;

          this.requestStatus = this.restudyRequestObj.BaseRequest.StatusId;
          this.eunitSignedUsersCount = this.restudyRequestObj.EunitSignedUsersNo || 0;
          if (this.eunitSignedUsersCount >= 2) {
            this.showProceedToManagers = true;
          }
          if(this.restudyRequestObj.BaseRequest.Attachments.length>0 &&  !this.currentRoute.includes("Refund") && (this.requestStatus == ServiceStatus.Restudy_PendingEconomicManagerApproval || this.requestStatus == ServiceStatus.Restudy_PendingEconomicApproval)){
            this.showAttachment = true;
          }
          this.isLoaded = true;
            if (history.state.data ) {
            this.decisionValue = this.restudyRequestObj.EunitRegistersDecision;
            //this.MdecisionValue = this.restudyRequestObj.EunitRegistersDecision;

            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Approve) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue,
               Approve: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            if((this.restudyRequestObj.EunitRegistersDecision != null && this.isReportURL) || this.isRestudyRoute){
                  this.showEconomicDecision=true;
            }
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Modify) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                Modify: this.restudyRequestObj.EunitRegisterNotes,
                Approve: this.restudyRequestObj.EunitModifyRebateNote
              });
            }
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Cancel) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                Cancel: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.MoreInformation) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            this.formMode = FormMode.Readonly;
            this.restudyManagerForm.disable();
          }
          debugger;
         if(this.requestStatus == ServiceStatus.Restudy_PendingEconomicManagerApproval){
            this.formMode = FormMode.Add;
            this.restudyManagerForm.enable();
          }
          else{
            this.formMode = FormMode.Readonly;
            this.EconomicManagerForm.disable();
            this.decisionValue = this.restudyRequestObj.EunitRegistersDecision;
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Modify) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                Modify: this.restudyRequestObj.EunitRegisterNotes,
                Approve: this.restudyRequestObj.EunitModifyRebateNote
              });
            }
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.MoreInformation) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Cancel) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                Cancel: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Approve) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue,
               Approve: this.restudyRequestObj.EunitRegisterNotes
              });}
            else {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue,
                //Approve: this.restudyRequestObj.EunitRegisterNotes
              });
            }
          }
        }
      }

    )

  }


  onSubmit(proceedToManagers: boolean) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.restudyManagerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

    // this.refundRequestObj = this.restudyManagerForm.value;
    this.restudyAdminObj.AdminEmail = this.user.UserName;
    this.restudyAdminObj.Id = this.baseRequestId;

    this.restudyAdminObj.EunitApproveDecision = this.MdecisionValue;
    this.restudyAdminObj.EunitRegistersDecision = this.decisionValue;
    //this.restudyAdminObj.EunitApproveNotes = this.EconomicManagerForm.controls.ManagerApprove.value;
    if (this.MdecisionValue == RestudyEconomicManagerDecision.Approve) {
     // this.restudyAdminObj.EunitApproveNotes = this.EconomicManagerForm.controls.ManagerApprove.value;
      this.restudyAdminObj.EunitSignedUsersCount = this.eunitSignedUsersCount + 1;

    } else {
      this.restudyAdminObj.EunitApproveNotes = this.EconomicManagerForm.controls.ManagerModify.value;
    }
    if (proceedToManagers) {
      this.restudyAdminObj.ProceedToManagers = true;
    }

    this.longhaulserv.SubmitEconomicManagerDecision(this.restudyAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.EconomicManagerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }
        });
  }
}
